var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWreathFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3772 34.1698C27.3772 34.1698 34.4263 29.9056 38.9999 36.8567C38.9999 36.8567 34.5038 42.7239 29.155 40.1037",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6227 30.9331C20.6227 30.9331 13.4186 26.6792 9 33.507C9 33.507 14.385 39.6362 18.7674 36.8259",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9976 28.467V46.5",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9922 42.6211C23.9922 42.6211 24.664 36.5177 31.7131 36.8311",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9922 38.994C23.9922 38.994 23.3203 32.8905 16.2712 33.2039L23.9922 38.994Z",
    fill: "#C9906A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9922 38.994C23.9922 38.994 23.3203 32.8905 16.2712 33.2039",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4136 9.66346C20.7211 3.95559 23.9924 3 23.9924 3C23.9924 3 27.2638 3.95559 26.5713 9.66859",
    fill: "#C9906A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4136 9.66346C20.7211 3.95559 23.9924 3 23.9924 3C23.9924 3 27.2638 3.95559 26.5713 9.66859",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8167 13.2752C13.2637 9.7251 14.8968 6.75043 14.8968 6.75043C14.8968 6.75043 17.889 5.12696 21.4601 9.65317",
    fill: "#C9906A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8167 13.2752C13.2637 9.7251 14.8968 6.75043 14.8968 6.75043C14.8968 6.75043 17.889 5.12696 21.4601 9.65317",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8425 18.3511C12.1009 19.0396 11.1396 15.7875 11.1396 15.7875C11.1396 15.7875 12.1009 12.5354 17.8477 13.2238",
    fill: "#C9906A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8425 18.3511C12.1009 19.0396 11.1396 15.7875 11.1396 15.7875C11.1396 15.7875 12.1009 12.5354 17.8477 13.2238",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4754 21.9269C17.9044 26.4532 14.9121 24.8297 14.9121 24.8297C14.9121 24.8297 13.2791 21.855 17.832 18.3049",
    fill: "#C9906A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4754 21.9269C17.9044 26.4532 14.9121 24.8297 14.9121 24.8297C14.9121 24.8297 13.2791 21.855 17.832 18.3049",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5815 21.9012C27.274 27.6091 24.0027 28.5647 24.0027 28.5647C24.0027 28.5647 20.7314 27.6091 21.4239 21.8961",
    fill: "#C9906A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5815 21.9012C27.274 27.6091 24.0027 28.5647 24.0027 28.5647C24.0027 28.5647 20.7314 27.6091 21.4239 21.8961",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1783 18.2946C34.7313 21.8447 33.0982 24.8194 33.0982 24.8194C33.0982 24.8194 30.106 26.4428 26.5349 21.9166",
    fill: "#C9906A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1783 18.2946C34.7313 21.8447 33.0982 24.8194 33.0982 24.8194C33.0982 24.8194 30.106 26.4428 26.5349 21.9166",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1526 13.2135C35.8942 12.5251 36.8555 15.7772 36.8555 15.7772C36.8555 15.7772 35.8942 19.0293 30.1475 18.3409",
    fill: "#C9906A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1526 13.2135C35.8942 12.5251 36.8555 15.7772 36.8555 15.7772C36.8555 15.7772 35.8942 19.0293 30.1475 18.3409",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5247 9.64292C30.0957 5.1167 33.088 6.74018 33.088 6.74018C33.088 6.74018 34.721 9.71485 30.1681 13.2649",
    fill: "#C9906A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5247 9.64292C30.0957 5.1167 33.088 6.74018 33.088 6.74018C33.088 6.74018 34.721 9.71485 30.1681 13.2649",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9974 18.3357C25.416 18.3357 26.5659 17.1925 26.5659 15.7823C26.5659 14.3721 25.416 13.2289 23.9974 13.2289C22.5789 13.2289 21.429 14.3721 21.429 15.7823C21.429 17.1925 22.5789 18.3357 23.9974 18.3357Z",
    fill: "white",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWreathFlower);
export default __webpack_public_path__ + "static/media/icon-wreath-flower.f1f4a6ddd62a101f135357a163ef3371.svg";
export { ForwardRef as ReactComponent };